<template>
  <v-container
    class="py-8 px-6"
    fluid
  >
    <PageTitle
      icon="mdi-home"
      main="RA2S"
      sub="Painel administrativo"
      home='/'
    />
    <v-container fluid>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          v-for="mm in buttons"
          :key="mm.id"
          class="mx-1 auto px-1"
          cols="12"
          sm="3"
          md="2"
          lg="1"
        >
          <v-card
            elevation="7"
            height="90"
            :to="mm.link"
          >
            <v-card
              color="white"
              class="py-1 mt-2 mb-0"
              flat
              tile
            >
              <v-img
                :src="mm.png_icon"
                max-width="50"
                class="my-1 mx-auto"
              >
              </v-img>
            </v-card>
            <v-card-text class="black--text ma-0 pt-0 px-1 text-menu">
              {{ mm.nome }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import axios from 'axios'
import { baseApiUrl } from '@/global'
export default {
  name: 'HomePage',
  computed: mapState(['user']),
  components: { PageTitle },
  data: () => ({
    buttons: [],
    buttonsOld: [
      { id: 1, nome: 'Administração', titulo: 'Àrea administrativa geral', icon: require('@/assets/icons/admin.png'), link: '/administracao' },
      { id: 2, nome: 'Compras', titulo: 'Àrea administrativa compras', icon: require('@/assets/icons/carts.png'), link: '/compras' },
      { id: 3, nome: 'Assistência Social', titulo: 'Àrea administrativa Assistência Social', icon: require('@/assets/icons/social.png'), link: '/social' },
      { id: 4, nome: 'Sic & Ouvidoria', titulo: 'Painel do Sic e Ouvidoria', icon: require('@/assets/icons/noticias.png'), link: '/home-sic' },
      { id: 5, nome: 'Notícias', titulo: 'Painel de notícias do site', icon: require('@/assets/icons/noticias.png'), link: '/noticias' }
    ]
  }),
  methods: {
    getTela () {
      if (this.user && this.user.id) {
        const id = this.user.id
        const url = `${baseApiUrl}/menu-tela/${id}`
        axios.get(url).then(res => {
          this.buttons = res.data
        })
      }
    }
  },
  mounted () {
    this.getTela()
  }

}
</script>

<style scoped>
.text-menu {
  text-align: center !important;
  font-size: 0.7rem !important;
  line-height: 0.75rem;
}
</style>
